import React from "react";
import { Link } from "react-router-dom";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import logo from "../../Assets/logo.png";
import { footerSocials } from "../../data/content";

const FOOTER_SOCIALS = [
  { href: footerSocials.github, label: "GitHub", Icon: AiFillGithub },
  { href: footerSocials.twitter, label: "Twitter", Icon: AiOutlineTwitter },
  { href: footerSocials.linkedin, label: "LinkedIn", Icon: FaLinkedinIn },
  { href: footerSocials.instagram, label: "Instagram", Icon: AiFillInstagram },
];

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <Link to="/" aria-label="Home">
            <img src={logo} alt="" />
          </Link>
          <p className="footer__credit">
            Designed and Developed by Dharmik Batra
            <span>Copyright © {year} DB</span>
          </p>
        </div>

        <ul className="footer__social-list">
          {FOOTER_SOCIALS.map(({ href, label, Icon }) => (
            <li key={label}>
              <a
                href={href}
                className="footer__social"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
              >
                <Icon />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </footer>
  );
}

export default Footer;
